import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

// subir linea a donde termina el parabrisas
const customTheme = createTheme({
  motorX: {
    darkGray: '#4F4C4C',
    gray: '#DADADA',
    lightGray: '#F6F6F6',
    red: '#E30613',
    blue: '#22B0FF',
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    letterSpacing: 0,
  },
  overrides: {
    // AppBar
    MuiAppBar: {
      root: {
        height: 100,
        boxShadow: 'none',
      },
      colorPrimary: {
        backgroundColor: 'transparent',
      },
      colorSecondary: {
        backgroundColor: 'white',
      },
    },
    // Typography
    MuiTypography: {
      h3: {
        textTransform: 'uppercase',
        fontWeight: 600,
      },
      h4: {
        textTransform: 'uppercase',
        fontWeight: 600,
      },
    },
    // Toolbar
    MuiToolbar: {
      root: {
        height: 100,
        backgroundColor: 'transparent',
      },
    },
    // Button
    MuiButton: {
      root: {
        borderRadius: 0,
      },
      contained: {
        borderRadius: 0,
      },
      outlined: {
        borderRadius: 0,
      },
    },
  },
  palette: {
    primary: {
      main: '#1D1D1B',
    },
    secondary: {
      main: '#FFD100',
    },
  },
});

const theme = responsiveFontSizes(customTheme);

export default theme;
